import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import AddPorschePaymentSettingsForm from './AddPorschePaymentSettingsForm';

export type PorschePaymentSettingsDrawerProps = {
    onClose: () => void;
    visible: boolean;
    moduleId: string;
};

const PorschePaymentSettingsDrawer = ({ onClose, visible, moduleId }: PorschePaymentSettingsDrawerProps) => {
    const { t } = useTranslation(['porschePaymentModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>
                        {t('porschePaymentModuleDetails:paymentSettingsDrawer.cancelButton')}
                    </Button>
                    <Button form="addPorschePaymentSettings" htmlType="submit" type="primary">
                        {t('porschePaymentModuleDetails:paymentSettingsDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('porschePaymentModuleDetails:paymentSettingsDrawer.title.create')}
            visible={visible}
            destroyOnClose
        >
            <AddPorschePaymentSettingsForm moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default PorschePaymentSettingsDrawer;

export const usePorschePaymentSettingsDrawer = (moduleId: string) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <PorschePaymentSettingsDrawer moduleId={moduleId} onClose={actions.close} visible={visible} />,
    };
};
